import { EndPoint } from '../../../apiConfigs';
import { AdvanceListingQueryApi, AdvanceListingResponse } from '../../../apiConfigs/@types';

export const fetchAdvanceListing = async () => {
  const resp = await fetch(EndPoint.AdvanceListing.ALL);
  const data = (await resp.json()) as AdvanceListingResponse;
  return data;
};

export const fetchQueryAdvanceListing = async (
  query: AdvanceListingQueryApi['Request'],
  reportStartDate: string,
  reportEndDate: string,
  occurence: string[],
) => {
  const searchParams = new URLSearchParams(query as Record<string, string>).toString();
  const resp = await fetch(EndPoint.AdvanceListing.ALL + '?' + searchParams);
  const data = (await resp.json()) as AdvanceListingResponse;

  occurence.length &&
    (data.features = data.features.filter((feature) =>
      occurence.some((occ) => feature.properties?.occurrence?.includes(occ)),
    ));
  reportStartDate &&
    reportEndDate &&
    (data.features = data.features.filter(
      (feature) =>
        feature.properties?.report_date >= reportStartDate &&
        feature.properties?.report_date <= reportEndDate,
    ));

  return data;
};
